module.exports = __webpack_public_path__ + "img/insta.97195756.png";